import { render, staticRenderFns } from "./FeedProductAuditLog.vue?vue&type=template&id=731050e0&"
import script from "./FeedProductAuditLog.vue?vue&type=script&lang=ts&"
export * from "./FeedProductAuditLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports